import React from 'react';
import './publications.css';
import PublicationCard from '../publicationCard/publicationCard'
import Grid from '@material-ui/core/Grid';
import { getPublications } from '../../services/contentService';
class Publications extends React.Component {
    constructor(props) {
      super(props);
      this.state = {projects:[],loading:true};
      // To use the 'this' keyword, we need to bind it to our function
    }
    async componentDidMount(){
        try {
            const projects = await getPublications();
            this.setState({projects,loading:false});
        } catch (_) {
            this.setState({projects:[], loading:false});
        }
    }

    handleSubmit(){

    }

    getloading(){
        return(
               <div className = 'loading loading-text'>
               Loading publications...
             </div>
        );
       }


       getGrid(){
        return(
            <Grid container className='gridList' alignItems="center"
   alignContent='space-between' spacing={3}>
            {this.state.projects.map(project=>(<Grid item key={project.slug} className='publication-card-grid' xs={6} sm={4}  md={3} lg={2}><PublicationCard item={project}/></Grid>))}
            </Grid>
        )
       }


    render(){ 
        const response = this.state.loading?this.getloading():this.getGrid();

        return (
            <div className="publication-card">
                <div className='title'>
                Publications
            </div>
            <div>
            {response}
        </div>
            </div>
        )
    }

}

export default Publications;